<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="deptPopup()"
          >新增部门</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>

    <el-table
      :data="tableData"
      v-loading="loading"
      :default-expand-all="true"
      row-key="id"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      @selection-change="handleSelectionChange"
      >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="deptName" label="部门名称"> </el-table-column>
      <el-table-column prop="parentName" label="上级部门"> </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="deptPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="deptDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 部门表单 -->
    <el-dialog  :close-on-click-modal="false" :append-to-body="true" :title="title" :visible.sync="deptFormVisible" width="30%" center>
      <el-form
        :model="deptForm"
        :size="$store.state.formSize"
        :rules="deptFormRules"
        ref="refDeptForm"
        label-width="100px"
      >
        <el-form-item label="上级部门：" prop="parentId">
          <el-cascader
            style="width:100%"
            v-model="deptForm.parentId"
            :options="pidData"
            :props="{ value: 'id', label: 'deptName', checkStrictly: true }"
            @change="handleChangeParentId"></el-cascader>
        </el-form-item>
        <el-form-item label="部门名称：" prop="deptName">
          <el-input
            v-model="deptForm.deptName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="deptFormVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getDeptTree,
  putDeptAdd,
  getDeptDetail,
  postDeptEdit,
  deleteDeptDel,
  delDeptList
} from '@/api/dept'

const createFormVals = () => ({
  parentId: null,
  deptName: ''
})

export default {
  data() {
    return {
      currentID: null,
      isDisabled: false,
      deptFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      tableData: [],
      pidData: [],
      detailDate: [],
      deptForm: createFormVals(),
      loading: true,
      selectionID: [],
      deptFormRules: {
        parentId: [
          { required: true, message: '请选择上级部门', trigger: 'blur' }
        ],
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑部门' : '新增部门'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.deptSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    // 选择父级ID
    handleChangeParentId(value) {
      console.log(value)
      if (value.length > 1) {
        this.deptForm.parentId = value[value.length - 1]
      } else {
        this.deptForm.parentId = value[0]
      }
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delDeptList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getDeptListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getDeptListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getDeptListData()
    },
    // 删除部门
    deptDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteDeptDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除部门成功')
              this.getDeptListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/编辑部门
    deptSubmit() {
      this.$refs.refDeptForm.validate(valid => {
        if (!valid) return false
        const changeDept = this.currentID ? postDeptEdit : putDeptAdd
        changeDept({
          deptName: this.deptForm.deptName,
          parentId: this.deptForm.parentId,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑部门成功') : this.$message.success('新增部门成功')
            this.deptFormVisible = false
            this.getDeptListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开部门表单
    deptPopup(id) {
      const isAdd = !id
      this.deptFormVisible = true

      if (isAdd) {
        this.$set(this, 'deptForm', createFormVals())
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getDeptDetail(id).then(res => {
          if (res.status === 1) {
            this.deptForm.deptName = res.data.deptName
            this.deptForm.parentId = res.data.parentId
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getDeptListData()
    },
    // 刷新数据表格
    refresh() {
      this.getDeptListData()
      this.$message.success('数据刷新成功')
    },
    // 获取部门列表
    getDeptListData() {
      this.loading = true
      getDeptTree().then(res => {
        if (res.status === 1) {
          if (res.data) {
            this.tableData = res.data
            this.pidData = res.data.slice()
            // this.pidData.unshift(
            //   {
            //     id: 0,
            //     parentId: 0,
            //     deptName: '顶级部门',
            //     idPath: '',
            //     isDel: 0,
            //     orgId: 0,
            //     parentName: null
            //   }
            // )
          }
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getDeptListData()
  }
}
</script>
